import { numberWithPercent } from '../../../_utils/utils'

/** What every surface renders in place of a rate it cannot report. */
export const BLANK_RATE = '--'

/**
 * Formats a rate measure for display.
 *
 * A rate of zero is rendered blank rather than "0.00%": across reporting the zero is almost
 * always an absent measurement rather than a measured zero, and showing it as a percentage
 * invites the reader to compare it with real rates. `null`/`undefined` (unknown) and `NaN`
 * (derived from an empty denominator) render blank for the same reason.
 *
 * A rate derived from a denominator that could be zero must still be guarded at the call
 * site: `n / 0` is `Infinity`, which is a number this cannot tell from a real rate.
 */
export function formatRateOrBlank(rate: number | null | undefined): string {
    return !rate ? BLANK_RATE : numberWithPercent(rate)
}
